import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["body", "chevronRight", "chevronDown"]
  static values  = { hasActive: Boolean }

  connect() {
    if (this.hasActiveValue) {
      this.open()
    } else {
      this.close()
    }
  }

  toggle() {
    this.bodyTarget.classList.contains("accordion-expanded") ? this.close() : this.open()
  }

  open() {
    this.bodyTarget.classList.add("accordion-expanded")
    this.chevronRightTarget.classList.add("hidden")
    this.chevronDownTarget.classList.remove("hidden")
  }

  close() {
    this.bodyTarget.classList.remove("accordion-expanded")
    this.chevronDownTarget.classList.add("hidden")
    this.chevronRightTarget.classList.remove("hidden")
  }
}
